import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalLongTask: ExperimentalQueries['experimentalLongTask'] = (
	_,
	{ taskId },
	{ network },
) =>
	fetchJSON(network, `/wiki/rest/api/longtask/${taskId}`, {
		cache: 'no-cache',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then((payload) => ({
		id: payload?.id || '',
		elapsedTime: payload?.elapsedTime || 0,
		percentageComplete: payload?.percentageComplete || 0,
		successful: payload?.successful || false,
		finished: payload?.finished || false,
		statusCode: payload?.statusCode || 200,
		messages: payload?.messages || [],
	}));
